import { render } from "./LandingStrasbourg.vue?vue&type=template&id=5fedc001&scoped=true"
import script from "./LandingStrasbourg.vue?vue&type=script&lang=js"
export * from "./LandingStrasbourg.vue?vue&type=script&lang=js"

import "./LandingStrasbourg.vue?vue&type=style&index=0&id=5fedc001&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fedc001"]])

export default __exports__